import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize, map } from 'rxjs/operators';

import { Router } from '@angular/router';
import { encryptStorage, environment } from '../../environments/environment';
import { AuthenticationService } from '../../app/services/authentication.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(
        private authenticationService: AuthenticationService,
        private spinner: NgxSpinnerService,
        private router: Router) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.spinner.show();
        //
        // add authorization header with jwt token if available
        if (request.headers.get('Anonymous') == "") {
            const newHeaders = request.headers.delete('Anonymous')
            const newRequest = request.clone({ headers: newHeaders });
            return next.handle(newRequest);
        }
        else {
            if (this.authenticationService.currentUserValue != null) {
                const currentUser = this.authenticationService.currentUserValue;
                if (currentUser && currentUser.token) {
                    var splitedurl = request.url.split("/");
                    if (splitedurl[2] == "10.195.96.100:7092" || splitedurl[2] == "localhost:44389" || splitedurl[2] == "apigateway.amnex.com" ) {
                        request = request.clone({
                            setHeaders: {
                                // 'Content-Type': "application/json",
                                Authorization: `${currentUser.token}`//`Bearer ${localStorage.get('token')}`
                            }
                        });
                    }
                    else if(splitedurl[2] == "localhost:34961")
                    {
                        request = request.clone({
                            setHeaders: {
                                 'Content-Type': "application/json",
                            }
                        });
                    }
                    else {
                        request = request.clone({
                            setHeaders: {
                                //For JWT autehntication
                                //Authorization: `Bearer ${currentUser.token}`

                                //For KeyCloak IDAM authentication
                                // 'Content-Type': "application/json",
                                Authorization: currentUser.token,
                                refreshToken: currentUser.refreshToken
                            }
                        });
                    }
                }
                else {
                    this.router.navigate(['']);
                }
            }
            else {
                //this.router.navigate([this.router.routerState.snapshot]);
                console.log('fjkbsjfaklsb', this.router.routerState.snapshot);
            }
        }

        return next.handle(request).pipe(
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    // console.log('event--->>>', event);
                    if (event.headers.has('authToken')) {
                        var refreshUserTokens = JSON.parse(JSON.stringify(encryptStorage.getItem('currentUser')))
                        refreshUserTokens.token = event.headers.get('authToken');
                        encryptStorage.removeItem('currentUser');
                        encryptStorage.setItem('currentUser', JSON.stringify(refreshUserTokens));

                    }
                    if (event.headers.has('AuthStatus')) {
                        encryptStorage.removeItem('currentUser');
                        //localStorage.setItem('currentUser',JSON.stringify(refreshUserTokens));

                    }
                }
                return event;
            }));
    }
}
